export const PLATFORM_HOME_PATH = '/create'
